<template>
  <v-container
    fluid
    class="pa-6 d-flex flex-column align-center justify-center"
  >
    <!-- Main Stepper -->
    <v-stepper v-model="step" class="elevation-3 rounded-xl" max-width="1200">
      <!-- Step Headers -->
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">Welcome</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2"
          >Create Organization</v-stepper-step
        >

        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3"
          >First Location</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 4" step="4"
          >Plan & Payment</v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card flat class="text-center py-10 px-6">
            <v-icon color="primary" size="80">mdi-hand-wave</v-icon>
            <h1 class="mt-4 font-weight-bold">Welcome to {{ clientName }}</h1>
            <p class="subtitle-1 grey--text mt-2">
              Let’s set up your organization, create your first location, and
              select your plan.
            </p>
            <v-btn color="primary" rounded large class="mt-6" @click="step = 2">
              Get Started
            </v-btn>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card flat class="pa-6">
            <h2 class="mb-4">Create Organization</h2>
            <p class="subtitle-2 grey--text mb-6">
              Enter your organization information. All your business data will
              be saved under this account.
            </p>

            <v-text-field
              v-model="Organization.name"
              label="Organization Name *"
              outlined
              dense
              autofocus
              color="primary"
              :error-messages="organizationNameErrors"
            />
            <v-text-field
              v-model="Organization.phoneNumber"
              label="Phone Number *"
              outlined
              dense
              color="primary"
              :error-messages="organizationPhoneNumberErrors"
            />
            <v-text-field
              v-model="Organization.email"
              label="Email *"
              outlined
              dense
              color="primary"
              :error-messages="organizationEmailErrors"
            />

            <v-row class="mt-6">
              <v-btn outlined rounded color="grey" @click="step = 1"
                >Back</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                rounded
                @click="nextStageAndPrefill"
                :disabled="$v.Organization.$invalid"
              >
                Continue
              </v-btn>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card flat class="pa-6">
            <h2 class="mb-4">Create Your First Location</h2>
            <p class="subtitle-2 grey--text mb-6">
              Start with your main store. This information will appear on
              receipts and invoices.
            </p>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="Location.name"
                  label="Business Name *"
                  outlined
                  dense
                  autofocus
                  color="primary"
                  :error-messages="locationNameErrors"
                />
              </v-col>

              <!-- <v-col cols="12" sm="6">
                <v-select
                  v-model="Location.businessType"
                  :items="businessTypes"
                  label="Business Type *"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                  color="primary"
                  :error-messages="businessTypeErrors"
                />
              </v-col> -->
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.email"
                  label="Email *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="locationEmailErrors"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.website"
                  label="Website (optional)"
                  outlined
                  dense
                  color="primary"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.Address.phoneNumber"
                  label="Phone Number *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="phoneErrors"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.Address.addressLine1"
                  label="Address Line 1 *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="addressLine1Errors"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.Address.addressLine2"
                  label="Address Line 2"
                  outlined
                  dense
                  color="primary"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.Address.city"
                  label="City *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="cityErrors"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="Location.Address.StateId"
                  :items="states"
                  item-text="name"
                  item-value="id"
                  label="State *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="stateIdErrors"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="Location.Address.postalCode"
                  label="Zip Code *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="postalCodeErrors"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="Location.Address.CountryCode"
                  :items="countries"
                  item-text="name"
                  item-value="code"
                  label="Country *"
                  outlined
                  dense
                  color="primary"
                  :error-messages="countryCodeErrors"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="Location.timeZone"
                  :items="timeZones"
                  item-text="label"
                  item-value="tzCode"
                  label="Time Zone *"
                  outlined
                  dense
                  color="primary"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-btn outlined rounded color="grey" @click="step = 2"
                >Back</v-btn
              >
              <v-spacer />
              <v-btn
                color="primary"
                rounded
                @click="step = 4"
                :disabled="$v.Location.$invalid"
              >
                Continue
              </v-btn>
            </v-row>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card flat class="pa-6">
            <h2 class="mb-4">Choose a Plan</h2>
            <v-container grid-list-lg>
              <p class="subtitle-2 grey--text mb-6">
                Pick a plan that fits your business needs. You can upgrade or
                cancel anytime.
              </p>

              <v-row>
                <v-col
                  v-for="plan in plans"
                  :key="plan.id"
                  cols="12"
                  sm="6"
                  md="4"
                  class="d-flex"
                >
                  <v-card
                    outlined
                    class="flex-grow-1 text-center plan-card"
                    :class="{
                      active: selectedPlan && selectedPlan.id === plan.id,
                    }"
                    @click="selectPlan(plan)"
                  >
                    <v-card-text>
                      <h3 class="font-weight-bold mb-2">{{ plan.name }}</h3>
                      <div class="display-1 font-weight-bold mb-2">
                        {{
                          parseFloat(plan.amount) > 0
                            ? `$${plan.amount}/mo`
                            : "Free"
                        }}
                      </div>
                      <p class="caption grey--text text--darken-1">
                        {{ plan.description }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <div
                v-if="selectedPlan && parseFloat(selectedPlan.amount) > 0"
                class="text-center mt-8"
              >
                <h3 class="mb-3">Payment Method</h3>
                <v-sheet class="pa-4 rounded-lg elevation-1" outlined>
                  <card
                    class="stripe-card my-4"
                    :class="{ complete }"
                    :stripe="stripePublicKey"
                    @change="complete = $event.complete"
                  />
                  <v-img
                    src="@/assets/images/powered_by_stripe.svg"
                    height="26"
                    contain
                    class="mx-auto"
                  />
                </v-sheet>
              </div>

              <div class="text-center mb-6 mt-5">
                <p class="font-weight-medium text--secondary">
                  By entering your card details and clicking
                  <strong>"Confirm & Create Organization"</strong>, you
                  authorize
                  <span class="font-weight-bold">{{ clientName }}</span> to
                  automatically charge your selected plan’s amount on a
                  recurring monthly basis until cancelled.
                </p>
              </div>

              <!-- Action Buttons -->
              <v-row class="mt-4">
                <v-btn outlined rounded color="grey" @click="step = 3">
                  Back
                </v-btn>
                <v-spacer />
                <v-btn
                  rounded
                  color="red darken-1"
                  dark
                  @click="submit"
                  :loading="isLoading"
                >
                  Confirm & Create Organization
                </v-btn>
              </v-row>
            </v-container>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import { Card, createToken } from "vue-stripe-elements-plus";
import { mapGetters, mapActions } from "vuex";
import timezones from "compact-timezone-list";
import publicService from "@/api/public";
import organizationService from "../Organization/service.js";

const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");

export default {
  name: "new-organization-stepper",
  components: { Card },
  mixins: [validationMixin],

  data() {
    return {
      step: 1,
      complete: false,

      stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      isLoading: false,

      clientName: "",
      appSource: "",

      timeZones: timezones,

      /* Organization form */
      Organization: {
        name: null,
        phoneNumber: null,
        email: null,
        cardToken: null,
      },

      /* Location form */
      Location: {
        name: null,
        businessType: null, // auto-filled by brand
        website: null,
        email: null,
        appSource: "",
        timeZone: this.$moment.tz.guess() || "America/New_York",
        Address: {
          addressLine1: null,
          addressLine2: null,
          city: null,
          StateId: null,
          CountryCode: 840,
          postalCode: null,
          phoneNumber: null,
        },
      },

      plans: [],
      selectedPlan: null,
    };
  },

  created() {
    this.applyBrandSettings();
    this.Location.appSource = this.appSource;
    this.fetchPlans();
  },

  computed: {
    ...mapGetters("global", ["states", "countries"]),
    ...mapGetters("brand", ["currentBrand"]),

    /* All validation errors stay unchanged */
    phoneErrors() {
      const e = [];
      if (!this.$v.Location.Address.phoneNumber.$dirty) return e;
      if (!this.$v.Location.Address.phoneNumber.required)
        e.push("Phone number is required.");
      return e;
    },
    organizationNameErrors() {
      const e = [];
      if (!this.$v.Organization.name.$dirty) return e;
      if (!this.$v.Organization.name.required)
        e.push("This field is required.");
      if (!this.$v.Organization.name.minLength)
        e.push("Must be at least 4 characters long.");
      return e;
    },
    organizationPhoneNumberErrors() {
      const e = [];
      if (!this.$v.Organization.phoneNumber.$dirty) return e;
      if (!this.$v.Organization.phoneNumber.required)
        e.push("Phone number is required.");
      if (!this.$v.Organization.phoneNumber.minLength)
        e.push("Invalid phone number.");
      return e;
    },
    organizationEmailErrors() {
      const e = [];
      if (!this.$v.Organization.email.$dirty) return e;
      if (!this.$v.Organization.email.required)
        e.push("This field is required.");
      if (!this.$v.Organization.email.email) e.push("Email is not valid.");
      return e;
    },
    locationNameErrors() {
      const e = [];
      if (!this.$v.Location.name.$dirty) return e;
      if (!this.$v.Location.name.required) e.push("This field is required.");
      if (!this.$v.Location.name.minLength)
        e.push("Must be at least 4 characters long.");
      return e;
    },
    locationEmailErrors() {
      const e = [];
      if (!this.$v.Location.email.$dirty) return e;
      if (!this.$v.Location.email.email) e.push("Email is not valid.");
      return e;
    },
    addressLine1Errors() {
      const e = [];
      if (!this.$v.Location.Address.addressLine1.$dirty) return e;
      if (!this.$v.Location.Address.addressLine1.required)
        e.push("Address is required.");
      return e;
    },
    cityErrors() {
      const e = [];
      if (!this.$v.Location.Address.city.$dirty) return e;
      if (!this.$v.Location.Address.city.required) e.push("City is required.");
      return e;
    },
    postalCodeErrors() {
      const e = [];
      if (!this.$v.Location.Address.postalCode.$dirty) return e;
      if (!this.$v.Location.Address.postalCode.required)
        e.push("Zip Code is required.");
      return e;
    },
    stateIdErrors() {
      const e = [];
      if (!this.$v.Location.Address.StateId.$dirty) return e;
      if (!this.$v.Location.Address.StateId.required)
        e.push("State is required.");
      return e;
    },
    countryCodeErrors() {
      const e = [];
      if (!this.$v.Location.Address.CountryCode.$dirty) return e;
      if (!this.$v.Location.Address.CountryCode.required)
        e.push("Country is required.");
      return e;
    },
  },

  methods: {
    ...mapActions("global", ["initOrganization"]),

    /* 🔥 Brand → Auto-fill label + business type + appSource */
    applyBrandSettings() {
      const brand = this.currentBrand;

      if (brand === "storesync") {
        this.clientName = "StoreSync POS";
        this.appSource = "storesyncpos";
        this.Location.businessType = "wireless"; // your default, change if needed
      } else if (brand === "autorepair") {
        this.clientName = "AutoRepair Desk";
        this.appSource = "autorepairdesk";
        this.Location.businessType = "auto";
      } else if (brand === "repairnest") {
        this.clientName = "RepairNest POS";
        this.appSource = "repairnestpos";
        this.Location.businessType = "repair";
      } else {
        // fallback
        this.clientName = "StoreSync POS";
        this.appSource = "storesyncpos";
        this.Location.businessType = "wireless";
      }
    },

    async fetchPlans() {
      try {
        const res = await publicService.GetPlans({
          audience: "LOCATION",
          includeIntegrations: true,
        });
        this.plans = res.data || [];
      } catch (e) {
        console.error("Error fetching plans", e);
      }
    },

    /* Continue to Location step */
    nextStageAndPrefill() {
      this.Location.name = this.Organization.name;
      this.Location.email = this.Organization.email;
      this.Location.Address.phoneNumber = this.Organization.phoneNumber;
      this.step = 3;
    },

    async selectPlan(plan) {
      if (plan.name === "Partner") {
        const { value: password } = await this.$swal.fire({
          title: "Enter Partner Code",
          input: "password",
          inputPlaceholder: "Enter code",
        });
        if (password === "setup2312141") this.selectedPlan = plan;
        else await this.$swal.fire("Invalid code, please try again.");
      } else {
        this.selectedPlan = plan;
      }
    },

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toasted.error("Please fill all required fields.", {
          position: "top-right",
        });
        return;
      }

      this.isLoading = true;

      try {
        const { token } = this.complete ? await createToken() : {};
        if (token) this.Organization.cardToken = token.id;

        if (this.selectedPlan) this.Location.planId = this.selectedPlan.planId;

        const res = await organizationService.create({
          Organization: this.Organization,
          Location: this.Location,
        });

        await this.initOrganization(res.data);
        this.$router.push({ path: "/" });
      } catch (err) {
        this.$toasted.error(
          err?.data?.message || "Failed to create organization.",
          { position: "top-right" }
        );
      } finally {
        this.isLoading = false;
      }
    },
  },

  /* Validation (business type removed) */
  validations: {
    Organization: {
      name: { required, minLength: minLength(4) },
      phoneNumber: { required, minLength: minLength(10) },
      email: { required, email },
    },
    Location: {
      name: { required, minLength: minLength(4) },
      email: { email },
      Address: {
        phoneNumber: { required, minLength: minLength(10) },
        addressLine1: { required },
        city: { required },
        postalCode: { required },
        StateId: { required },
        CountryCode: { required },
      },
    },
  },
};
</script>

<style scoped>
.business-tile {
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  background: #fff;
  min-height: 240px;
}
.business-tile:hover {
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  transform: translateY(-3px);
}
.business-tile.active {
  border: 2px solid #1976d2;
  background: linear-gradient(145deg, #e3f2fd, #ffffff);
  box-shadow: 0 0 10px rgba(25, 118, 210, 0.3);
}
.plan-card {
  border: 1px solid #eee;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}
.plan-card:hover {
  border-color: #2196f3;
  box-shadow: 0 6px 16px rgba(33, 150, 243, 0.15);
}
.plan-card.active {
  border: 2px solid #2196f3;
  background: linear-gradient(145deg, #f0f9ff, #ffffff);
}
.stripe-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 14px;
  background: #fff;
}
</style>